<!-- CouponUserHelpModal.vue -->
<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >
        Sobre a seção Usuário-Cupom
      </h2>

      <p class="text-sm leading-relaxed text-gray-800 mb-3">
        Nesta página, você acompanha os <strong>vínculos diretos entre usuários
        e coupons TARGETED</strong>. Esse tipo de vínculo é usado quando um
        coupon não deve ficar disponível para qualquer pessoa, mas apenas para
        usuários previamente autorizados.
      </p>

      <div
        class="mb-4 rounded-md border border-blue-200 
 bg-blue-50  px-3 py-2.5"
      >
        <p class="text-sm text-blue-900 leading-relaxed">
          <strong>Dica:</strong> use esta seção para controlar quais usuários
          podem usar coupons direcionados. Um coupon com regra
          <strong>TARGETED</strong> normalmente exige que exista um vínculo
          ativo nesta tela para que o usuário consiga utilizá-lo.
        </p>
      </div>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          A coluna <strong>Cupom</strong> mostra o código do coupon vinculado
          ao usuário.
        </li>

        <li>
          A coluna <strong>Usuário</strong> identifica quem recebeu o direito
          de uso daquele coupon.
        </li>

        <li>
          A coluna <strong>Situação</strong> informa se o vínculo ainda está
          <strong>ativo</strong> ou se foi <strong>revogado</strong>.
        </li>

        <li>
          A coluna <strong>Resgate</strong> mostra se o usuário já utilizou
          efetivamente o coupon.
        </li>

        <li>
          A data <strong>Atribuído em</strong> indica quando o coupon foi
          liberado para o usuário.
        </li>

        <li>
          A data <strong>Revogado em</strong> indica quando o vínculo perdeu
          validade por ação administrativa.
        </li>

        <li>
          A data <strong>Resgatado em</strong> indica quando o coupon foi
          consumido pelo usuário.
        </li>

        <li>
          Clique sobre uma linha da tabela para abrir o
          <strong>card de detalhes</strong> do vínculo.
        </li>

        <li>
          Use o menu da coluna <strong>Ações</strong> para visualizar, editar
          ou apagar o vínculo, conforme as permissões disponíveis.
        </li>

        <li>
          Marque vários vínculos na primeira coluna para executar
          <strong>ações em lote</strong>.
        </li>
      </ul>

      <div
        class="mb-4 rounded-md border border-yellow-200 
 bg-yellow-50  px-3 py-2.5"
      >
        <p class="text-sm text-yellow-900 leading-relaxed">
          <strong>Atenção:</strong> revogar um vínculo impede novos usos daquele
          coupon por esse usuário, mas não apaga o histórico de atribuição ou de
          resgate já realizado.
        </p>
      </div>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

